import { Flex, TabList } from '@lokalise/louis';

import styled from '@app/styled';
import { mediaQuery, spacing, typography } from '@app/theme';

export const TabListContainer = styled(TabList)`
    margin-bottom: ${spacing(5)};
`;

export const ModalFooter = styled(Flex)`
    width: 100%;
    padding-top: ${spacing(6)};
`;

export const UpgradePlanMessage = styled(Flex)`
    ${typography('body')};
    margin: ${spacing(8, 0, 6, 0)};
`;

export const SplitView = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${spacing(6)};
    align-items: flex-start;
`;

export const SwitchWrapper = styled.div`
    padding-top: ${spacing(1)};
`;

export const EnterprisePerks = styled(Flex)`
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-gap: ${spacing(5, 5)};
    padding-top: ${spacing(4)};

    ${mediaQuery.max('sm')} {
        grid-template-columns: repeat(1, auto);
    }
`;
